import React from 'react';
import { Link } from 'react-router-dom';
import { PhoneIcon, MailIcon } from 'lucide-react';
import { site } from '../data/site';
type CTABandProps = {
  title?: string;
  description?: string;
};
export function CTABand({
  title = 'Ready for a free estimate?',
  description = 'Tell us what you need repaired, updated or renovated and we will get you a no-cost estimate.'
}: CTABandProps) {
  return <section className="bg-safety" data-id="element-97" data-mp="3v22tu5a73a2c">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-10 md:flex-row md:items-center md:justify-between" data-id="element-98" data-mp="3v0ro3zx6vs8l">
        <div className="max-w-xl" data-id="element-99" data-mp="2v4bwvx0vhi1">
          <h2 className="font-display text-3xl font-bold uppercase leading-tight tracking-tight text-white" data-id="element-100" data-mp="7np5pxfxhulk">
            {title}
          </h2>
          <p className="mt-2 text-base text-white/90" data-id="element-101" data-mp="cmih9kbnnbj3">{description}</p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row" data-id="element-102" data-mp="hnof1wk69ozh">
          <a href={site.estimatePhone.href} className="flex items-center justify-center gap-2 rounded-sm bg-ink px-6 py-3.5 text-base font-bold uppercase tracking-wide text-white transition hover:bg-ink-800" data-id="element-103" data-mp="ml7ydavq8rya">
            <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-104" data-mp="1jf95ddk9we4s" />
            {site.estimatePhone.display}
          </a>
          <Link to="/contact" className="flex items-center justify-center gap-2 rounded-sm border-2 border-white px-6 py-3.5 text-base font-bold uppercase tracking-wide text-white transition hover:bg-white hover:text-safety-600" data-id="element-105" data-mp="1ejtsooy04o9y">
            <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-106" data-mp="228ms4vdu1e9b" />
            Request Online
          </Link>
        </div>
      </div>
    </section>;
}